export const Icon = () => {
    return (
        <svg viewBox="0 0 70 60" width="70" height="60" fill="none" stroke="#D4BC87">
            <rect x="6" y="10" width="58" height="40" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10.832 10L34.9987 35L59.1654 10" />
            <path d="M6 50.0006L25.3333 25.7148" />
            <path fillRule="evenodd" clipRule="evenodd" d="M64.0004 50.0006L43.9766 25.7148L64.0004 50.0006Z" />
        </svg>
    );
};
